import { filterOptions } from '@/utils/query-base'

// const be = filterOptions(['EQ'])
const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export const pageSearch = {
}

export default {
  'partner': {
    title: '客户编号',
    type: 'dialog',
    equation: all,
    width: 200,
    dialog: {
      component: 'ClientSelect',
      title: '客户编号'
    }
  },
  'name': {
    title: '客户名称',
    type: 'input',
    width: 250
  },
  'zzfld000016': {
    title: '客户类型',
    describe: true,
    suffix:'_text',
    width: 200,
  },
  'zzfld00001h': {
    title: '营销单元',
    describe: true,
    suffix:'_text',
    width: 200,
  },
  'zzfld00003e': {
    title: '基地',
    describe: true,
    suffix:'_text',
    width: 200,
  },
}


// WEBPACK FOOTER //
// ./src/views/apply-for-manage/base-setting/config/newWineCustomer.js